var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup308361(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 32,
    viewBox: "0 0 132 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7713 0L52.6655 6.15385H39.4872L38.2891 13.037H48.1498L47.044 18.963H37.1833L34.8793 32H27L32.7137 0H53.7713Z",
    fill: "#0C213A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7557 26.0741H70.0772L69.0174 32H50.8166L56.5303 0H64.4096L59.7557 26.0741Z",
    fill: "#0C213A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5432 26.3476H80.4707L77.5217 32H69.2737L86.6912 0H95.8147L101.805 32H93.4647L92.5432 26.3476ZM91.6216 20.4217L89.7324 8.5698L83.5579 20.4217H91.6216Z",
    fill: "#0C213A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.523 25.6182H127.438L126.286 32H103.432L104.491 26.0741L121.817 6.38177H107.993L109.145 0H132L130.94 5.92593L113.523 25.6182Z",
    fill: "#0C213A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0L18.5446 32H11L16.4554 0H24Z",
    fill: "#80B7EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0L8.12494 32H0L5.875 0H14Z",
    fill: "#348BDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup308361);
export default __webpack_public_path__ + "static/media/Group 30836 (1).527777e52f3ac2c2749ac63a164c1a08.svg";
export { ForwardRef as ReactComponent };